import {
  styled,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
} from '@mui/material';

export const TableContainerStyled = styled(TableContainer)({
  border: '1px solid var(--neutral-grey-200, #E6E6E6)',
  boxShadow: 'none',
  borderRadius: '4px',
}) as typeof TableContainer;

export const DetailsTableStyled = styled(Table)({
  width: '100%',
});

export const DetailsTableBodyStyled = styled(TableBody)({});

export const DetailsTableRowStyled = styled(TableRow)({
  '@media (max-width: 743px)': {
    borderBottom: '1px solid #e6e6e6',
  },
});

export const DetailCellStyled = styled(TableCell)({
  '@media (max-width: 743px)': {
    paddingBottom: '0px',
    '&:last-child': {
      paddingBottom: '24px',
    },
  },
});

export const DetailBoxStyled = styled('div')({
  padding: '24px 20px',
  '@media (max-width: 743px)': {
    paddingBottom: '0px',
    '&:last-child': {
      paddingBottom: '24px',
    },
  },
});

export const DetailTitleCellStyled = styled(DetailCellStyled)({
  fontSize: '14px',
  '@media (max-width: 743px)': {
    maxWidth: '146px',
    paddingLeft: '12px',
  },
});

export const PlanDetailsContainerStyled = styled(Box)({
  '@media (max-width: 743px)': {
    display: 'flex',
    flexDirection: 'column',
  },
});

export const BoldCellTextStyled = styled(Typography)({
  fontSize: '14px',
  fontWeight: '600',
}) as typeof Typography;

export const NetworkDetailSmall = styled('div')({
  textAlign: 'left',
});

export const DetailsBoxStyled = styled('div')({
  marginTop: '44px',
  textAlign: 'left',
});

export const DetailPillStyled = styled(Box)({
  border: '1px solid #e6e6e6',
  borderRadius: '4px',
  backgroundColor: 'var(--neutral-grey-200, #E6E6E6)',
  padding: '4px 8px',
  width: 'fit-content',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '10px',
  letterSpacing: '1.5px',
  gap: '8px',
  textTransform: 'uppercase',
});
